<template>
  <div class="collapsible-section">
    <div 
      class="section-header" 
      @click="toggleCollapse" 
      :style="{ '--header-justify': headerJustify }"
    >
      <div class="header-content">
        <span class="section-title">{{ title }}</span>
        <span v-if="required" class="required-mark">必須</span>
      </div>
      <div class="toggle-icon" :class="{ 'collapsed': isCollapsed }">
        <i class="fas fa-chevron-up"></i>
      </div>
    </div>
    <div class="section-content" v-show="!isCollapsed">
      <div class="content-wrapper">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormCollapsibleSection',
  props: {
    title: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    initialCollapsed: {
      type: Boolean,
      default: false
    },
    headerJustify: {
      type: String,
      default: 'space-between'
    }
  },
  data() {
    return {
      isCollapsed: this.initialCollapsed
    }
  },
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed
    }
  }
}
</script>

<style scoped>
.collapsible-section {
  background-color: #FFF;
  border-radius: 4px;
  margin: 5px;
  overflow: hidden;
}

.section-header {
  display: flex;
  justify-content: var(--header-justify, space-between);
  align-items: center;
  padding: 10px 20px;
  cursor: pointer;
  background-color: #FFF;
}

.header-content {
  display: flex;
  align-items: center;
}

.section-title {
  font-weight: 700;
  margin-right: 10px;
}

.required-mark {
  background-color: #ff0000;
  color: white;
  padding: 2px 5px;
  border-radius: 3px;
  font-size: 12px;
  text-align: center;
  display: inline-block;
}

.toggle-icon {
  transition: transform 0.3s ease;
}

.toggle-icon.collapsed {
  transform: rotate(180deg);
}

.section-content {
  border-top: 3px solid #195983;
}

.content-wrapper {
  padding: 10px 20px;
}
</style>
